module.exports = __webpack_public_path__ + "static/img/android6.5cd0e6fd.jpg";